module.exports = __webpack_public_path__ + "static/media/karl1.2697c29b.jpg";